import type { HubAccessLevel, HubInvitationStatus } from "@gamedev-web/one-gaming-crm";

export type AdminInvitationStatus =
  | HubInvitationStatus.Pending
  | HubInvitationStatus.Rejected
  | HubInvitationStatus.Revoked
  | HubInvitationStatus.Expired;
export type AdminContactLifecycleAction = "removeHubAccess" | "removeFromCompany";

export type AdminContact = {
  contactId: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  hubRole: HubAccessLevel | null;
  isHubEnabled: boolean;
  isCurrentUser: boolean;
  isAccountContact: boolean;
  isPrimarySignatory: boolean;
  isTestData: boolean;
  crmUrl?: string;
};

export type AdminContactAccessInput = {
  accessLevel: HubAccessLevel;
};

export type AdminInvitation = {
  invitationId: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  accessLevel: HubAccessLevel;
  status: AdminInvitationStatus;
  createdOn: string;
  expiresOn: string;
  invitedBy: string;
  isTestData: boolean;
};

export type AdminInvitationInput = {
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  accessLevel: HubAccessLevel;
};

export enum AdminInvitationConflict {
  ExistingContact = "CONTACT_ALREADY_HAS_HUB_ACCESS",
  ExistingInvitation = "INVITATION_ALREADY_EXISTS",
}
